import React, {Component} from "react";
// La instancia de i18next directa y NO `src/i18n.js`: esta clase es la base de media docena de
// tooltips del Tablero, y `src/i18n.js` hace `.use(initReactI18next)` al importarse — rompe las
// suites que mockean `react-i18next` sin ese stub. En la app es la misma instancia, que `index.js`
// ya inicializó.
import i18n from "i18next";

export class AlertTooltip extends Component {
    render() {
        let tooltipContent = this.tooltipContent();
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-marker">
                    <i className="fa fa-circle" aria-hidden="true"/>
                </div>
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <p className="alert-tooltip-title">{this.props.comparisonWithAverageValue}</p>
                        {/*<div className="alert-tooltip-options">*/}
                        {/*<button className="snooze-button"></button>*/}
                        {/*</div>*/}
                    </div>
                    {tooltipContent}
                </div>
            </div>

        )
    }

    tooltipContent() {
        // Este texto decía "ayer" —y agregaba una nota sobre el retraso de 24hs de Google
        // Analytics— cuando la línea medía sus conversiones con GA4. El dato que lo activaba
        // (`track_conversions_using_analytics`) hace tiempo que ningún presenter lo emite, así que
        // la rama era inalcanzable. De dónde sale hoy el número lo dice la columna Conversiones
        // con su propio rótulo (card YKJQUySh).
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-metric">
                    {`${this.props.metricValue} ${this.props.metricName} hoy`}
                </p>
                <p className="alert-tooltip-description">
                    {`Esta cuenta tuvo ${this.props.metricValue} de ${this.props.metricName} hoy
                    y ${this.props.metricExpextedValue} en el pasado.`}
                </p>
                <p>
                    {this.renderHasNoActionsSelectedNotice()}
                </p>
            </div>
        );
    }

    renderHasNoActionsSelectedNotice() {
        if (this.props.hasMetaActionsAndAreNotSet) {
            return (
                <p className="alert-tooltip-description">
                    {i18n.t('alert_tooltip.meta_actions_not_set')}
                </p>
            )
        } else {
            return null;
        }
    }
}
